module.exports = __webpack_public_path__ + "img/tutorial_course_03.33c82876.gif";